import React from 'react';

import Proptypes from 'prop-types';
import { Box, StackView, TextInput } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const ContractRecipient = ({ contractRecipient, setContractRecipient }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      emailDetail: {
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail
      }
    }
  } = localizedStrings;

  return (
    <StackView space={3}>
      <TextInput
        label={contractAddress}
        hint={contractAddressDetail}
        value={contractRecipient.to || ''}
        onChange={(value) =>
          setContractRecipient({ ...contractRecipient, to: value })
        }
      />
      <TextInput
        label={CCEmailAddress}
        hint={CCEmailAddressDetail}
        value={contractRecipient.cc || ''}
        onChange={(value) =>
          setContractRecipient({ ...contractRecipient, cc: value })
        }
      />
    </StackView>
  );
};

ContractRecipient.propTypes = {
  contractRecipient: Proptypes.shape({
    to: Proptypes.string,
    cc: Proptypes.string
  }).isRequired,
  setContractRecipient: Proptypes.func.isRequired
};

export default ContractRecipient;
